// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"0b13a049","358":"bea4c85e","551":"0e7ec5f5","718":"646aacd0","787":"3f259038","848":"a74ad209"}[chunkId] + ".chunk.js";
};